import { COLLAPSED, IFRAME, IFRAME_LOADING } from "@/store/actions/navigation";

const state = { status: null, iframe: false, iframeLoading: false };

const getters = {
  getDrawerStatus: (state) => state.status,
  getIframeStatus: (state) => state.iframe,
  getIframeLoadingStatus: (state) => state.iframeLoading,
};

const actions = {
  [COLLAPSED]: ({ commit, dispatch }) => {
    commit(COLLAPSED);
  },
  [IFRAME_LOADING]: ({ commit, dispatch }, value) => {
    commit(IFRAME_LOADING, value);
  },
};

const mutations = {
  [COLLAPSED]: (state, value) => {
    if (value) state.status = true;
    else state.status = false;
  },
  [IFRAME]: (state, value) => {
    if (value) {
      state.iframe = true;
      state.iframeLoading = true;
    } else {
      state.iframe = false;
      state.iframeLoading = false;
    }
  },
  [IFRAME_LOADING]: (state, value) => {
    if (value) state.iframeLoading = true;
    else state.iframeLoading = false;
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
